import { sortAlphabeticallyByKey } from '@fortem-monorepo/js-utilities'

export const PRICE_TYPES = ['notional', 'notionalflat', 'unit', 'unitlev', 'etf'] as const

export type PriceType = (typeof PRICE_TYPES)[number]

export const PRICE_TYPE_LABELS: Record<PriceType, string> = {
  notional: 'Notional',
  notionalflat: 'Notional Flat',
  unit: 'Unit',
  unitlev: 'Unit Lev',
  etf: 'ETF',
}

export const PRICE_TYPE_OPTIONS = sortAlphabeticallyByKey(
  PRICE_TYPES.map((p) => ({
    label: PRICE_TYPE_LABELS[p],
    value: p,
  })),
  'label',
)
